module.exports = __webpack_public_path__ + "static/media/shoot.45425916.gif";